import React from 'react';
import PropTypes from 'prop-types';
import unescape from 'unescape';
import I18nLink from '~/components/I18nLink';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';

@withI18next()
class Breadcrumb extends React.PureComponent {
  render() {
    const { categories, title, t, lng } = this.props;

    return (
      <div className="ac-breadcrumb">
        {categories.length === 0 && (
          <ol
            className="breadcrumb__item"
            itemScope
            itemType="https://schema.org/BreadcrumbList"
          >
            <li
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
              name={t('design_Home')}
            >
              <I18nLink href={{ pathname: '/' }} shallow>
                <a
                  className={`ac-link ${Config.getPrefixContent(
                    'color-ac-primary',
                  )}`}
                  itemProp="item"
                  href="/"
                >
                  <span itemProp="name"> {t('design_Home')}</span>
                </a>
              </I18nLink>
              <meta itemProp="position" content="1" />
            </li>
            {title && <div className="divider">{'>'}</div>}
            {title && (
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
                name={unescape(title)}
              >
                <a itemProp="item">
                  <span itemProp="name">
                    {' '}
                    <h1
                      className="active"
                      dangerouslySetInnerHTML={{ __html: unescape(title) }}
                    />
                  </span>
                </a>
                <meta itemProp="position" content="2" />
              </li>
            )}
          </ol>
        )}
        <style jsx>
          {`
            .ac-breadcrumb {
              padding: 10px 0px;
            }
            .ac-breadcrumb .breadcrumb__item {
              margin: 0 0;
              white-space: nowrap;
              display: flex;
              flex-direction: row;
              align-items: center;
            }
            .ac-breadcrumb .breadcrumb__item .divider {
              margin: 0 8px;
              color: ${themeVariables.colors.bodyText};
              border: none;
              font-weight: 700;
            }
            .ac-breadcrumb .breadcrumb__item .active {
              font-weight: 700;
              color: rgba(0, 0, 0, 0.7);
            }
            .ac-breadcrumb .breadcrumb__item h1 {
              margin: 0;
              padding: 0;
              font-size: 16px;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.7);
            }
            ol {
              padding: 0;
            }
            ol li {
              list-style-type: none;
            }
            @media only screen and (max-width: ${themeVariables.breakpoints
                .tabletS.maxWidth}px) {
              .ac-breadcrumb .breadcrumb__item .active {
                white-space: normal;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

Breadcrumb.propTypes = {
  categories: PropTypes.array,
  title: PropTypes.string,
};

Breadcrumb.defaultProps = {
  categories: [],
  title: '',
};

export default Breadcrumb;
